import { createFileRoute } from '@tanstack/react-router';

import { EmployeeProfile } from '@/components/employee/profile';

export const Route = createFileRoute('/(app)/employee/profile/')({
  component: EmployeeProfileRoute,
});

function EmployeeProfileRoute() {
  return (
    <EmployeeProfile
      showEditButton={false}
      showBackButton={false}
      viewContext="employee"
    />
  );
}
